module.exports = __webpack_public_path__ + "img/Back.be4c876.svg";